document.addEventListener('DOMContentLoaded', function () {

    // ================================
    // MAIN BANNER
    // ================================
    const bannerElement = document.querySelector('#main-banner-slider');

    if (bannerElement && typeof Swiper !== 'undefined') {

        new Swiper('#main-banner-slider', {
            loop: true,
            speed: 1000,

            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            effect: 'fade',

            fadeEffect: {
                crossFade: true
            },

            pagination: {
                el: '#main-banner-slider .swiper-pagination',
                clickable: true,
            },

            navigation: {
                nextEl: '#main-banner-slider .swiper-button-next',
                prevEl: '#main-banner-slider .swiper-button-prev',
            },
        });

    }


    // ================================
    // REVIEWS
    // ================================
    const reviewElement = document.querySelector('#review-p');

    if (reviewElement && typeof Swiper !== 'undefined') {

        new Swiper('#review-p', {
            loop: true,
            speed: 600,

            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            pagination: {
                el: '.what-people-say-pagination',
                clickable: true,
            },

            autoHeight: true,

            effect: 'fade',

            fadeEffect: {
                crossFade: true
            }
        });

    }


    // ================================
    // BLOG
    // ================================
    const blogElement = document.querySelector('#blg-grid');

    if (blogElement && typeof Swiper !== 'undefined') {

        const slideElements = blogElement.querySelectorAll('.swiper-slide');
        const totalSlides = slideElements.length;

        if (totalSlides <= 3) {
            blogElement.classList.add('blg-area-grid-mode');
        }

        new Swiper('#blg-grid', {
            slidesPerView: 1,
            spaceBetween: 20,

            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },

            rewind: true,

            pagination: {
                el: '.blg-area-pagination',
                clickable: true
            },

            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    enabled: true
                },

                992: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                    enabled: totalSlides > 3
                }
            }
        });

    }


    // ================================
    // CERTIFICATION
    // ================================
    const certElement = document.querySelector('.certification-swiper');

    if (certElement && typeof Swiper !== 'undefined') {

        new Swiper('.certification-swiper', {
            slidesPerView: 2,
            spaceBetween: 12,

            pagination: {
                el: '.certification-pagination',
                clickable: true,
            },

            navigation: {
                nextEl: '.certification-swiper .swiper-button-next',
                prevEl: '.certification-swiper .swiper-button-prev',
            },

            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                },

                521: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },

                901: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                }
            }
        });

    }


    // ================================
    // PRODUCTS
    // ================================
    const productElement = document.querySelector('#product-list-d');

    if (productElement && typeof Swiper !== 'undefined') {

        new Swiper('#product-list-d', {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,

            pagination: {
                el: '#product-list-d .swiper-pagination',
                clickable: true,
            },

            breakpoints: {
                767: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },

                1024: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    enabled: false
                }
            }
        });

    }


    // ================================
    // VERTICAL PRODUCT THUMBNAILS
    // ================================
    const thumbsElement = document.querySelector(
        '.vertical-thumb-area-thumbs-swiper'
    );

    const mainElement = document.querySelector(
        '.vertical-thumb-area-main-swiper'
    );

    if (
        thumbsElement &&
        mainElement &&
        typeof Swiper !== 'undefined'
    ) {

        const thumbsSwiper = new Swiper(
            '.vertical-thumb-area-thumbs-swiper',
            {
                direction: 'vertical',
                slidesPerView: 5,
                spaceBetween: 10,
                slideToClickedSlide: true,
                watchSlidesProgress: true,
                freeMode: false,
                mousewheel: true,

                breakpoints: {
                    0: {
                        direction: 'horizontal',
                        slidesPerView: 4,
                        spaceBetween: 8
                    },

                    767: {
                        direction: 'vertical',
                        slidesPerView: 5,
                        spaceBetween: 10
                    }
                }
            }
        );


        const mainSwiper = new Swiper(
            '.vertical-thumb-area-main-swiper',
            {
                spaceBetween: 0,

                effect: 'fade',

                fadeEffect: {
                    crossFade: true
                },

                speed: 350,

                thumbs: {
                    swiper: thumbsSwiper,
                },
            }
        );


        mainSwiper.on('slideChange', function () {
            thumbsSwiper.slideTo(mainSwiper.activeIndex);
        });

    }

});

function increaseQuantity() {
    var qtyInput = document.getElementById('featured-prod-qty-input');

    if (!qtyInput) return;

    var currentValue = parseInt(qtyInput.value) || 1;

    qtyInput.value = currentValue + 1;
}


function decreaseQuantity() {
    var qtyInput = document.getElementById('featured-prod-qty-input');

    if (!qtyInput) return;

    var currentValue = parseInt(qtyInput.value) || 1;

    if (currentValue > 1) {
        qtyInput.value = currentValue - 1;
    }
}


function changeFeaturedImage(src) {
    var mainImage = document.getElementById('featured-prod-main-img');

    if (!mainImage) return;

    mainImage.src = src;

    var thumbs = document.querySelectorAll('.featured-prod-thumb');

    thumbs.forEach(function (thumb) {
        thumb.classList.remove('active');

        if (thumb.src === src) {
            thumb.classList.add('active');
        }
    });
}
// Script to smoothly close announcement bar on click
               const closeAnnouncementBtn = document.querySelector('.header-menu-announcement-close');
               if (closeAnnouncementBtn) {
                    closeAnnouncementBtn.addEventListener('click', function() {
                         const announcementBar = document.querySelector('.header-menu-announcement-bar');
                         if (announcementBar) {
                              announcementBar.classList.add('header-menu-hidden');
                         }
                    });
               }
               // Script to toggle mobile menu smoothly on hamburger click
               const hamburgerBtn = document.querySelector('.header-menu-hamburger-btn');
               const mobileMenu = document.querySelector('.header-menu-mobile-menu');
               if (hamburgerBtn && mobileMenu) {
                    hamburgerBtn.addEventListener('click', function() {
                         mobileMenu.classList.toggle('header-menu-open');
                    });
               }
               // Script to toggle search bar open/close
               const searchToggleBtn = document.querySelector('.header-menu-search-toggle-btn');
               const searchBarContainer = document.getElementById('searchBarContainer');
               const searchCloseBtn = document.querySelector('.header-menu-search-close-btn');
               const searchInput = document.querySelector('.header-menu-search-input');
               if (searchToggleBtn && searchBarContainer) {
                    searchToggleBtn.addEventListener('click', function() {
                         searchBarContainer.classList.add('header-menu-search-open');
                         // Automatically focus the input field when opened
                         if (searchInput) {
                              setTimeout(() => searchInput.focus(), 200);
                         }
                         // Close mobile menu if open
                         if (mobileMenu && mobileMenu.classList.contains('header-menu-open')) {
                              mobileMenu.classList.remove('header-menu-open');
                         }
                    });
               }
               if (searchCloseBtn && searchBarContainer) {
                    searchCloseBtn.addEventListener('click', function() {
                         searchBarContainer.classList.remove('header-menu-search-open');
                         if (searchInput) {
                              searchInput.value = '';
                         }
                    });
               }
               // Script to smoothly hide header on scroll down & show on reverse scroll
            //    const header = document.querySelector('.header-menu-header-container');
            //    if (header) {
            //         let lastY = window.scrollY || document.documentElement.scrollTop;
            //         let isHidden = false;
            //         window.addEventListener('scroll', function() {
            //              const currentY = window.scrollY || document.documentElement.scrollTop;
            //              if (currentY <= 10) {
            //                   if (isHidden) {
            //                        header.classList.remove('header-menu-scroll-hidden');
            //                        isHidden = false;
            //                   }
            //                   lastY = currentY;
            //                   return;
            //              }
            //              if (currentY > lastY && !isHidden) {
            //                   header.classList.add('header-menu-scroll-hidden');
            //                   isHidden = true;
            //                   if (mobileMenu && mobileMenu.classList.contains('header-menu-open')) {
            //                        mobileMenu.classList.remove('header-menu-open');
            //                   }
            //                   if (searchBarContainer && searchBarContainer.classList.contains('header-menu-search-open')) {
            //                        searchBarContainer.classList.remove('header-menu-search-open');
            //                   }
            //              } else if (currentY < lastY && isHidden) {
            //                   header.classList.remove('header-menu-scroll-hidden');
            //                   isHidden = false;
            //              }
            //              lastY = currentY;
            //         }, {
            //              passive: true
            //         });
            //    }